import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import IconCloseEye from "../../component/SvgIcon/IconCloseEye";
import IconLogIn from "../../component/SvgIcon/IconLogIn";
import IconOpenEye from "../../component/SvgIcon/IconOpenEye";
import IconReset from "../../component/SvgIcon/IconReset";
import IconUser from "../../component/SvgIcon/IconUser";
import { useAuth } from "../../services/AuthContext";
import api from "../../services/index";
import "./style.css";

import Swal from "sweetalert2";
export default function Login() {
  const [showForgot, setShowForgot] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const { isLoggedIn, setIsLoggedIn, setCountry, setUserType, setToken } = useAuth();
  const navigate = useNavigate();

  if (isLoggedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  function scheduleLogoutAtMidnight() {
    const now = new Date();
    const midnight = new Date();
    // Set time to next midnight
    midnight.setHours(24, 0, 0, 0);
    const msUntilMidnight = midnight.getTime() - now.getTime();
    // Save logout time for reference
    localStorage.setItem("logoutAt", midnight.getTime());
    // ✅ Automatically logout at midnight
    setTimeout(() => {
      localStorage.clear();
      window.location.href = "/"; // Redirect to login
      alert("Your session expired. Please login again.");
    }, msUntilMidnight);
  }

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username.trim() || !password.trim()) {
      alert("Please enter username and password");
      return;
    }

    setLoading(true);
    // if super admin adtive then use this code
    try {
      const response = await api.post("/adminlogin", { username, password });
      console.log("Login response:", response);
      if (response.data?.token) {
        // console.log("User type from response:", response.data.user.userType);
        // console.log("Country from response:", response.data.user.country); 

        setIsLoggedIn(true);
        setUserType(response.data.user.userType);
        setCountry(response.data.user.country);
        setToken(response.data.token);

        // ✅ Save username and image (if you have) to localStorage
        localStorage.setItem("userId", response.data.user.id);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        localStorage.setItem("username", response.data.user.username);
        localStorage.setItem("userImage", response.data.user.image || "https://picsum.photos/35/35");
        localStorage.setItem("loginTime", Date.now());

        // ✅ Schedule logout for midnight
        scheduleLogoutAtMidnight();

        navigate("/dashboard", {
          state: {
            UserType: response.data.user.userType,
            Country: response.data.user.country,
          },
        });
      } else {
        alert("Invalid username or password");
      }
    } catch (error) {
      //   console.error("Login error:", error);
      //   Swal.fire({
      //   icon: 'error',
      //   title: 'Login Failed',
      //   text: "😕 Oops! That user doesn't match our records.",
      //   confirmButtonText: 'Try Again'
      // });

      console.error("Login error:", error);

      if (error.code === "ERR_NETWORK") {
        // ✅ Handle network error separately
        Swal.fire({
          icon: 'warning',
          title: 'Connection Issue',
          text: "🌐 Unable to connect. Please check your internet connection or try again later.",
          confirmButtonText: 'Retry'
        });
      } else {
        // ✅ Handle other errors (invalid credentials, server errors, etc.)
        Swal.fire({
          icon: 'error',
          title: 'Login Failed',
          text: "😕 Oops! That user doesn't match our records.",
          confirmButtonText: 'Try Again'
        });
      }

    }
    finally {
      setLoading(false);
    }
  };

  // super admin not login


  // if not need super admin then use this code
  // try {
  //   const response = await api.post("/adminlogin", { username, password });
  //   console.log("Login response:", response);

  //   const user = response.data.user;

  //   // ✅ Block login for Super Admin
  //   if (user.userType.toLowerCase() === "super") {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Access Denied",
  //       text: "Super Admin cannot log in from this portal.",
  //       confirmButtonText: "OK",
  //     });
  //     setLoading(false);
  //     return; // Stop further execution
  //   }

  //   if (response.data?.token) {
  //     setIsLoggedIn(true);
  //     setUserType(user.userType);
  //     setCountry(user.country);
  //     setToken(response.data.token);

  //     localStorage.setItem("username", user.username);
  //     localStorage.setItem("userImage", user.image || "https://picsum.photos/35/35");
  //     localStorage.setItem("loginTime", Date.now());

  //     // Schedule logout at midnight
  //     scheduleLogoutAtMidnight();

  //     navigate("/dashboard", {
  //       state: {
  //         UserType: user.userType,
  //         Country: user.country,
  //       },
  //     });
  //   } else {
  //     alert("Invalid username or password");
  //   }
  // } catch (error) {
  //   console.error("Login error:", error);
  //   Swal.fire({
  //     icon: "error",
  //     title: "Login Failed",
  //     text: "😕 Oops! That user doesn't match our records.",
  //     confirmButtonText: "Try Again",
  //   });
  // } finally {
  //   setLoading(false);
  // }
  // };

  const handleForgotSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      alert("Password reset link sent to your email.");
      setShowForgot(false);
      setLoading(false);
    }, 1500);
  };

  return (
    <div className="form-area">
      <div className="form-container">
        <picture className="loginphone">
          <img src="../images/phone.svg" alt="track" />
        </picture>
        <div className="wrapper">
          <h2>{showForgot ? "Forgot Password" : "Member Login"}</h2>
          <picture>
            <img src="../track.png" alt="track" />
          </picture>

          {!showForgot ? (
            <form onSubmit={handleLogin} className="d-flex flex-column gap-4">
              <div className="input-group">
                <input
                  type="text"
                  placeholder="Username"
                  autoComplete="new-username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
                <span>
                  <IconUser />
                </span>
              </div>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  autoComplete="new-password"
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <IconOpenEye /> : <IconCloseEye />}
                </span>
              </div>
              <button
                type="submit"
                className="btn loginbtn btn-success"
                disabled={loading}
              >
                {loading ? "Login..." : "Login "}
                <IconLogIn />
              </button>
            </form>
          ) : (
            <form
              onSubmit={handleForgotSubmit}
              className="d-flex flex-column gap-4"
            >
              <div className="input-group">
                <input type="email" placeholder="Enter your email" required />
                <span>
                  <IconUser />
                </span>
              </div>
              <button
                type="submit"
                className="btn loginbtn btn-success"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Reset Link"}
                <IconReset />
              </button>
            </form>
          )}

          <div className="options">
            <button
              type="button"
              className="forgotpassword"
              onClick={() => !loading && setShowForgot(!showForgot)}
            >
              {showForgot ? "Back to Login" : "Forgot Password?"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
